import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import { getLocalizedCaseDisplay } from '../../data/caseProfiles';
import { getDoctorEmojiForGender } from '../../utils/userAvatar';
import './Chat.css';

const ChatContainer = ({ messages, selectedCase, isTyping }) => {
  const { language, t } = useLanguage();
  const { user } = useAuth();
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  if (!selectedCase) {
    return (
      <div className="empty-state">
        <div className="empty-icon">{getDoctorEmojiForGender(user?.gender)}</div>
        <h3>Welcome to MedTrain AI</h3>
        <p>Select a patient case from the sidebar to begin your clinical training session.</p>
        <p className="empty-hint">Each case presents unique challenges for diagnosis and management.</p>
      </div>
    );
  }
  const displayCase = getLocalizedCaseDisplay(selectedCase, language);

  return (
    <div className="chat-container" ref={containerRef}>
      {messages.map((msg) => (
        <ChatMessage 
          key={msg.id} 
          message={msg} 
          patientName={displayCase.name}
        />
      ))}
      
      {isTyping && (
        <div className="chat-message ai typing">
          <div className="message-avatar">
            <div className="avatar-patient">👤</div>
          </div>
          <div className="message-content">
            <div className="message-header">
              <span className="sender-name">{displayCase.name}</span>
            </div>
            <div className="typing-indicator">
              <span>{t('patientTyping')}</span>
              <div className="typing-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatContainer;
